const popularReducer = (state = [], {type, restaurants}) => {
    switch(type) {
        case 'SET_POPULAR':
            return restaurants;
        default: 
            return state;
    }
}

export default popularReducer;